import React, { useCallback, useEffect, useRef } from 'react';
import { Autocomplete, Checkbox, Paper, TextField } from '@mui/material';
import { inputsStyle } from './styles';
import { Colors } from '../../utils';
import { TextRow } from '../table';
import { ErrMessage } from '../messages';

/** Autocomplete paper with a footer under the options; mousedown on it keeps the input focused. */
export const FooterPaper = ({ children, footer, ...paperProps }) => (
    <Paper {...paperProps}>
        {children}
        {footer && <div onMouseDown={(e) => e.preventDefault()}>{footer}</div>}
    </Paper>
);

export const CheckboxesTags = ({
    label,
    permissionsList,
    placeholder,
    handleChange,
    styles,
    typeError,
    noChip,
    name,
    value,
    disabled,
    renderValue,
    inputType,
    uiType,
    outLabel,
    CustomPaperComponent,
    notShowError,
    textRow,
    removeWhenClose,
    renderRow,
    variant,
}) => {
    const classes = inputsStyle();
    const classname = !noChip ? classes.noChip : '';
    const listboxScrollTop = useRef(0);
    const listboxRef = useRef(null);

    const inputStyle = inputType === 'serviceType' ? classes.serviceTypeAutocompleteStyle : classes.autocompleteStyle;

    // Restore scroll position after value change triggers a re-render
    useEffect(() => {
        if (listboxRef.current && listboxScrollTop.current > 0) {
            const savedPos = listboxScrollTop.current;
            requestAnimationFrame(() => {
                if (listboxRef.current) {
                    listboxRef.current.scrollTop = savedPos;
                }
            });
        }
    }, [value]);

    const handleListboxScroll = useCallback((event) => {
        listboxScrollTop.current = event.target.scrollTop;
    }, []);

    const listboxRefCallback = useCallback((node) => {
        if (node) {
            listboxRef.current = node;
            if (listboxScrollTop.current > 0) {
                node.scrollTop = listboxScrollTop.current;
            }
        }
    }, []);

    return (
        <div>
            {outLabel && <p id='labelTitle' className={classes.labelTitle}>{outLabel}</p>}
            <>
                <Autocomplete
                    onClose={() => removeWhenClose && handleChange([])}
                    disabled={disabled}
                    className={
                        uiType === 'tableFilter'
                            ? classes.noChipSelectMultiple
                            : uiType === 'defaultCheckboxSelect'
                              ? classes.inputTextFieldCheckboxAuto
                              : uiType === 'modalCheckboxSelect'
                                ? classes.inputTextFieldCheckboxes
                                : `${inputStyle} ${classname}`
                    }
                    multiple
                    value={value}
                    defaultValue={value}
                    style={styles}
                    id="checkboxes-tags-demo"
                    key={permissionsList}
                    options={permissionsList}
                    disableCloseOnSelect
                    isOptionEqualToValue={(option, value) => option?.id === value?.id}
                    onChange={(event, value) => handleChange(value)}
                    ListboxProps={{
                        onScroll: handleListboxScroll,
                        ref: listboxRefCallback,
                    }}
                    getOptionLabel={(option) => (renderValue ? renderValue(option) : option.title)}
                    slots={{ paper: FooterPaper }}
                    slotProps={{ paper: { footer: CustomPaperComponent } }}
                    renderOption={(props, option, { selected }) => {
                        const { key, ...restProps } = props;
                        return (
                            <li key={key} {...restProps}>
                                <div style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                    <Checkbox style={{ padding: '2px 8px 2px 0', color: Colors.ThemeBlue }} checked={selected} />
                                    {renderRow ? (
                                        renderRow(option, selected)
                                    ) : (
                                        <div style={{ width: '100%' }}>
                                            <p style={{ width: '100%' }}>
                                                {!textRow ? (
                                                    renderValue ? (
                                                        renderValue(option)
                                                    ) : (
                                                        option.title
                                                    )
                                                ) : (
                                                    <TextRow name={renderValue ? renderValue(option) : option.title} textWidth={8} />
                                                )}
                                            </p>
                                            {name === 'permissions' && (
                                                <p
                                                    style={{
                                                        color: 'gray',
                                                        fontSize: '12px',
                                                    }}
                                                >
                                                    {' '}
                                                    {option?.description}
                                                </p>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </li>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            error={typeError}
                            className={classes.inputTextFieldAutoHeight}
                            variant={variant ? variant : 'outlined'}
                            label={label}
                            placeholder={placeholder}
                        />
                    )}
                    // PopperComponent={CustomPaperComponent}
                />
                {!notShowError && <ErrMessage text={typeError} />}
            </>
        </div>
    );
};
